exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".EditTRouteModal-39764390 .cols-7c64e951{display:flex}.EditTRouteModal-39764390 .col1-6c23ca52{flex:1;margin-right:40px}.EditTRouteModal-39764390 .col2-171326f1{flex:1}\n", ""]);

// Exports
exports.locals = {
	"EditTRouteModal": "EditTRouteModal-39764390",
	"cols": "cols-7c64e951",
	"col1": "col1-6c23ca52",
	"col2": "col2-171326f1"
};